var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkforceIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 28.833,
    viewBox: "0 0 39 28.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "insights",
    d: "M18.709,95.335a2.635,2.635,0,1,0,4.878-1.378l4.83-4.377a2.628,2.628,0,0,0,3.559-.348L36.2,91.774a2.635,2.635,0,1,0,4.689-.5l4.892-4.593a2.636,2.636,0,1,0-.665-.708l-4.892,4.593a2.629,2.629,0,0,0-3.522.376L32.478,88.4a2.635,2.635,0,1,0-4.713.46l-4.83,4.376a2.632,2.632,0,0,0-4.226,2.1Zm5.342,5.585a.486.486,0,0,1,.485.485v8.378h2.279V95.364a.486.486,0,0,1,.485-.485h5.415a.485.485,0,0,1,.485.485v14.418H35.48v-10.6a.486.486,0,0,1,.485-.485h5.415a.486.486,0,0,1,.485.485v10.6h2.279V92.315a.485.485,0,0,1,.485-.485h5.415a.486.486,0,0,1,.485.485v17.467h2.823a.485.485,0,0,1,0,.971H15.325a.485.485,0,1,1,0-.971h2.824V101.4a.486.486,0,0,1,.485-.485Z",
    transform: "translate(-14.84 -81.92)",
    fill: "#3db6fb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforceIntelligence);
export default __webpack_public_path__ + "static/media/Workforce Intelligence.e4790851e964b963c4c698e1972bb52a.svg";
export { ForwardRef as ReactComponent };